import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const AVATARS = [
  "https://images.unsplash.com/photo-1772987273687-4866382c146f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBjb3Jwb3JhdGUlMjBwb3J0cmFpdCUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc3NzMwODIwMHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1767175620484-1ed37931a0d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBjb3Jwb3JhdGUlMjBwb3J0cmFpdCUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc3NzMwODIwMHww&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/10657877/pexels-photo-10657877.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

const REVIEWS = [
  {
    name: "Marina Lopes",
    role: "CTO · OrionXR",
    quote:
      "AnimaSoftware delivered a real-time training simulator running flawlessly at 90 fps on standalone headsets. They are the engineering partner we wished we'd hired sooner.",
    avatar: AVATARS[0],
  },
  {
    name: "Daniel Ferreira",
    role: "Product Lead · Helios Industrial",
    quote:
      "Our digital twin platform finally feels like software, not a demo. Their attention to performance budgets and pipelines is rare and absolutely worth it.",
    avatar: AVATARS[1],
  },
  {
    name: "Rafael Costa",
    role: "Founder · Studio Volta",
    quote:
      "From day one they understood our creative ambition and translated it into a robust 3D web experience. Insanely talented team — and a joy to ship with.",
    avatar: AVATARS[2],
  },
];

export default function Reviews() {
  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="relative py-24 sm:py-32 px-5 sm:px-8"
    >
      <div className="max-w-7xl mx-auto">
        <div className="mb-14">
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-[#00FF66]">
              Social Proof
            </div>
            <h2
              className="mt-4 text-3xl sm:text-5xl lg:text-6xl font-black leading-[1.05] tracking-tighter max-w-3xl"
              data-testid="reviews-headline"
            >
              Trusted by teams shipping <span className="text-gradient">serious 3D.</span>
            </h2>
          </div>
        </div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          variants={{
            hidden: {},
            show: { transition: { staggerChildren: 0.12 } },
          }}
          className="grid md:grid-cols-3 gap-5"
        >
          {REVIEWS.map((r, i) => (
            <motion.figure
              key={r.name}
              variants={{
                hidden: { opacity: 0, y: 24 },
                show: { opacity: 1, y: 0, transition: { duration: 0.55 } },
              }}
              data-testid={`review-card-${i + 1}`}
              className="group relative rounded-2xl border border-white/10 bg-[#101010] p-7 hover:border-[#FF6B00]/40 hover:-translate-y-1 transition-all duration-300"
            >
              <Quote className="h-7 w-7 text-[#FF6B00]/70 mb-4" />
              <blockquote className="text-[15px] leading-relaxed text-gray-200">
                "{r.quote}"
              </blockquote>
              <figcaption className="mt-7 flex items-center gap-3">
                <img
                  src={r.avatar}
                  alt={r.name}
                  className="h-11 w-11 rounded-full object-cover border border-white/10"
                />
                <div>
                  <div className="font-semibold text-white text-sm">{r.name}</div>
                  <div className="text-xs text-gray-400">{r.role}</div>
                </div>
                <div className="ml-auto flex items-center gap-0.5">
                  {Array.from({ length: 5 }).map((_, k) => (
                    <Star
                      key={k}
                      className="h-3.5 w-3.5 fill-[#FF6B00] text-[#FF6B00]"
                    />
                  ))}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
